import React from "react";
import styles from "./styles.module.sass";
import { Typography, Icon24Checkmark } from "@cur8/maneki";

interface ChecklistItemProps {
  checked?: boolean;
  children: React.ReactNode;
}

export function ChecklistItem({ checked, children }: ChecklistItemProps) {
  return (
    <div className={styles.ChecklistItem} data-checked={checked}>
      <div className={styles.icon}>
        <Icon24Checkmark />
      </div>
      <div className={styles.content}>
        <Typography as="span" variant="body-m">
          {children}
        </Typography>
      </div>
    </div>
  );
}
